export const permissoesRelatoriosChamadas = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_OUVIR_GRAVACAO,
  process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_TOTAL,
]

export const permissoesRelatoriosConferencias = [
  process.env.VUE_APP_ADMINISTRADOR,
  process.env.VUE_APP_RELATORIO_PABX_CONFERENCIAS_VISUALIZAR_CONDICIONADO,
  process.env.VUE_APP_RELATORIO_PABX_CONFERENCIAS_OUVIR_GRAVACAO,
  process.env.VUE_APP_RELATORIO_PABX_CONFERENCIAS_TOTAL,
]
